'use strict';

var keysTransform = require('./keys-transform.cjs');

const positionalKeys = new Set([
    "width",
    "height",
    "top",
    "left",
    "right",
    "bottom",
    ...keysTransform.transformPropOrder,
]);

exports.positionalKeys = positionalKeys;
//# sourceMappingURL=keys-position.cjs.map
